module.exports = __webpack_public_path__ + "img/cpzz8@2x.28d35adb.png";